import $, { extend } from 'jquery';
import React from 'react';
import {UserToken,getUserObjData} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,CallMapMethod_CBack,setEventsLib,RespBkMthdMapp} from '../function_lib/common_lib';
import Wa_Channel_Add from '../components/wa_channel_add';
import Header from '../user_pages/header';
import Footer from '../user_pages/footer';
import Option_Module from '../user_pages/option_module';
import LogoImg from '../assets/images/logo_p_small.png';
import defaultPic from '../assets/images/9.png';



let loginUser="";
let userObject="";
let companyName="";
let clsChannelMgmt;

let rf="0";

class Channel_Mgmt extends React.Component{
    forceUpdateHandler(){
        this.forceUpdate();
      };

    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
            userObject= getUserObjData();
            //alert(JSON.stringify(userObject));
            loginUser=userObject[0].first_name;
            companyName=userObject[0].first_name;
        }
        clsChannelMgmt=this;
        this.state={ listThrashold:[]};
          this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
      }

      editThrasholdData(e_id,e_key,text){
        var map=[];
        map.push({name:"curl_type",value:"editThrashold"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].app_user_id});
        map.push({name:"user_type",value:userObject[0].type});
        map.push({name:"upper_id",value:userObject[0].upper_id});

        map.push({name:"e_id",value:e_id});
        map.push({name:"e_key",value:e_key});
        map.push({name:"e_value",value:text});

        map["res_func"]="callBackrrr";
        map["curl_type"]="editThrashold";
        CallMapMethod_CBack(clsChannelMgmt,map,function(data,msg){
          if(data==="001"){
            alert("Updated Successfully");
          }   
          
        })
      }

      getChannelMgmt(status="0"){
        //child component use this method loan_document_upload_comp
        var map=[];
        map.push({name:"curl_type",value:"getChannel"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].app_user_id});
        map.push({name:"user_type",value:userObject[0].type});
        map.push({name:"upper_id",value:userObject[0].upper_id});
        map["res_func"]="callBackrrr";
        map["curl_type"]="getChannel";
        CallMapMethod_CBack(clsChannelMgmt,map,function(data,msg){
          //alert(data);
            if(data!=="0" && data!==""){
                let listData=JSON.parse(data);
                var strData="";
                clsChannelMgmt.setState({listThrashold:listData},()=>{
                  clsChannelMgmt.forceUpdateHandler();
                  RespBkMthdMapp(clsChannelMgmt,"_setbackparam","onDelCustomRel");
                    setEventsLib("editable","confirm",function(e_id,e_key,text){
                      clsChannelMgmt.editThrasholdData(e_id,e_key,text);
                    })
                  //RespBkMthdMapp(clsUserMgmt,"_btnShareOption","");
                 
                  if(rf!=="0"){
                    clsChannelMgmt.getSearch(rf);
                    //alert("i m in setup "+rf);
                    $("#serLoanStatus").val(rf);
                  }
                });
                
               
              }
        });
      }
      
      okSucc(data,msg){
        
        if(data==="001"){
          alert(msg);
          clsChannelMgmt.getChannelMgmt();
        }
        
      }    
      onDelChannel(p1,p2){
        if(window.confirm("Kindly confirm to process Delete!")===true){
          let map=[];
          map.push({name:"curl_type",value:"removeExChannel"});
          map.push({name:"res_func",value:"callBackrrr"});
          map.push({name:"local_token",value:userObject[0].app_user_id});
          map.push({name:"id",value:p1});
          map.push({name:"contact_no",value:p2});
          map["res_func"]="callBackrrr";
          map["curl_type"]="removeExChannel";
          CallMapMethod_CBack(clsChannelMgmt,map,function(data,msg){
            if(data==="001"){
              alert("deleted successfully");
              clsChannelMgmt.getChannelMgmt();
            }
          })
  
        }
       


      }      
      
componentDidMount(){
   this.getChannelMgmt();

  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);
}


      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
    
<div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
         
      <div class="card">
              {/* <!-- /.card-header --> */}
              <div class="card-header bg-cyan">
                <h3 class="card-title "><i class="fa fa-arrow-circle-right"></i> <b>Channel Mgmt</b></h3>
                
                <a className="btn btn-sm btn-danger float-right" data-toggle="modal" data-target="#divWaThrashold" href="javascript:void(0)">Add New</a>
              </div>
                <table class="dtgrid dtgrid table table-bordered table-hover text-sm text-nowrap table-responsive">
                  <thead>
                    <tr class="border">
                      <th>S.No.</th>
                      <th>Id</th>
                      <th>Contact No</th>
                      <th>Instance Id</th>
                      <th>Access Token</th>
                      <th>Status</th>
                      <th>Entry Date</th>
                      <th>Updated Date</th> 
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody id="tbData">
                  {(this.state.listThrashold.map((item,index)=>{
                       return(<tr>
                        <td>{index+1}</td>
                    <td>{item.id}</td>
                    <td>{item.contact_no}</td>
                  <td className='editable1212' e_id={item.id} e_key={"allow_limit"}>{item.token_id}</td>
                  <td className='editabl1212e' e_id={item.id} e_key={"slot_size"} >{item.access_token}</td>
                  <td>{item.status}</td>
                  <td>{item.creation_date}</td>
                  <td>{item.transaction_date}</td>
                  <td>
                    <a href="javascript:void(0)" resback={"onDelChannel"} className="_setbackparam" param1={item.id} param2={item.contact_no}><i class="fa fa-times"></i></a>
                  </td>
                    </tr>)
                  }))}
                  </tbody>
                </table>
           
              
              {/* <!-- /.card-body --> */}
            </div>
      </div>
</div>
</div>
</div>
<Footer/>
<Wa_Channel_Add user_object={userObject}/>
          </div>)
      }
}
export default Channel_Mgmt;